module.exports = __webpack_public_path__ + "img/061.8478372c.png";